import { ModelConstants } from '../model-constants';
import { IAttribute, IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { AzureKeyVault } from './key-vault';
import { format } from '../../shared/utils/string.util';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';
import { GlobalVariables } from '../../constants/globals';
import { GetIRTypeFromLocalModel } from '../../integrationruntime/util';

export const sftpAuthTypes = {
    Basic: 'Basic',
    SshPublicKey: 'SshPublicKey',
    MultiFactor: 'MultiFactor'
};

export enum SftpPrivateKeyType {
    Content = 'Content',
    Path = 'Path'
}
@Metamodel.model({
    name: ModelConstants.sftpLinkedService,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Sftp_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Sftp_DisplayText)
    ]
})
export class SftpServerLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    public static readonly HOST: IAttribute;
    public static readonly PORT: IAttribute;
    public static readonly HOST_KEY_FINGERPRINT: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly PRIVATE_KEY_PATH: IAttribute;
    public static readonly PRIVATE_KEY_CONTENT: IAttribute;
    public static readonly PASS_PHRASE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host,
        association: 'HOST',
        templatable: true
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port,
        association: 'PORT',
        templatable: true
    })
    public port?: number = 22;

    @Metamodel.attribute({
        display: stringResources.ModelName_SkipHostKeyValidation
    })
    public skipHostKeyValidation?: boolean = false;

    @Metamodel.attribute({
        display: stringResources.ModelName_HostKeyFingerprint,
        association: 'HOST_KEY_FINGERPRINT',
        templatable: true
    })
    public hostKeyFingerprint?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    public privateKeyType?: SftpPrivateKeyType;

    @Metamodel.attribute({
        display: stringResources.ModelName_PrivateKeyPath,
        association: 'PRIVATE_KEY_PATH',
        templatable: true
    })
    public privateKeyPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_PrivateKeyContent,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'PRIVATE_KEY_CONTENT',
        templatable: true,
        accepts: ['String']
    })
    public privateKeyContent?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_PassPhrase,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'PASS_PHRASE',
        templatable: true,
        accepts: ['String']
    })
    public passPhrase?: string | AzureKeyVault;

    public isExistingResourceUsingPrivateKeyPath: boolean = false;

    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: 'v1' | 'v2' = GlobalVariables.enableSFTPV2 ? 'v2' : undefined;

    // determine if the linkedservice is a old resource, if it is old resource and version is v1, then will not save the version when _toResource
    public isOldResource: boolean = !GlobalVariables.enableSFTPV2;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public editingErrorMessageCustomizer(): string {
        return this.privateKeyType === SftpPrivateKeyType.Path && this.isAzureIR ? stringResources.SFTP_PublicKeyPath_AzureIR_Error : '';
    }

    public get isAzureIR(): boolean {
        // default to auto resolved IR
        const irType = GetIRTypeFromLocalModel(this.integrationRuntime);
        return this.integrationRuntime == null || irType === 'Azure' || irType === 'ManagedVNet';
    }
}
